package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.merkost.handpass.admin.container.ToastHostContainer
import com.merkost.handpass.admin.contract.ToastHostIntent
import com.merkost.handpass.admin.contract.ToastKind
import com.merkost.handpass.sharedweb.components.WebToast
import com.merkost.handpass.sharedweb.components.WebToastKind
import com.merkost.handpass.sharedweb.theme.HandpassSpacing
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import com.merkost.handpass.admin.di.koinContainer
import pro.respawn.flowmvi.compose.dsl.subscribe

private fun ToastKind.toWebKind(): WebToastKind = when (this) {
    ToastKind.Success -> WebToastKind.Success
    ToastKind.Error -> WebToastKind.Error
    ToastKind.Info -> WebToastKind.Info
}

@Composable
fun AdminToastHost() {
    val container = koinContainer<ToastHostContainer>()
    with(container.store) {
        val state by subscribe { _ -> }
        Div(
            attrs = Modifier
                .position(Position.Fixed)
                .styleModifier {
                    property("bottom", "${HandpassSpacing.XL}")
                    property("right", "${HandpassSpacing.XL}")
                }
                .display(DisplayStyle.Flex)
                .flexDirection(FlexDirection.Column)
                .gap(10.px)
                .zIndex(600)
                .toAttrs()
        ) {
            state.entries.forEach { entry ->
                WebToast(
                    message = entry.message,
                    kind = entry.kind.toWebKind(),
                    actionLabel = entry.actionLabel,
                    exiting = entry.exiting,
                    onAction = { intent(ToastHostIntent.InvokeAction(entry.id)) },
                    onDismiss = { intent(ToastHostIntent.Dismiss(entry.id)) },
                )
            }
        }
    }
}
